var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_2261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22101 11.0453C9.35869 11.1085 9.51381 11.123 9.6608 11.0863C9.8078 11.0496 9.9379 10.9639 10.0297 10.8433L10.2663 10.5333C10.3905 10.3677 10.5516 10.2333 10.7367 10.1407C10.9219 10.0482 11.126 9.99998 11.333 9.99998H13.333C13.6866 9.99998 14.0258 10.1405 14.2758 10.3905C14.5259 10.6406 14.6663 10.9797 14.6663 11.3333V13.3333C14.6663 13.6869 14.5259 14.0261 14.2758 14.2761C14.0258 14.5262 13.6866 14.6666 13.333 14.6666C10.1504 14.6666 7.09816 13.4024 4.84773 11.1519C2.59729 8.90149 1.33301 5.84924 1.33301 2.66665C1.33301 2.31302 1.47348 1.97389 1.72353 1.72384C1.97358 1.47379 2.31272 1.33331 2.66634 1.33331H4.66634C5.01996 1.33331 5.3591 1.47379 5.60915 1.72384C5.8592 1.97389 5.99967 2.31302 5.99967 2.66665V4.66665C5.99967 4.87364 5.95148 5.07779 5.85891 5.26293C5.76634 5.44807 5.63194 5.60912 5.46634 5.73331L5.15434 5.96731C5.03195 6.06076 4.94569 6.1937 4.9102 6.34355C4.87472 6.49339 4.8922 6.6509 4.95967 6.78931C5.8708 8.63989 7.36929 10.1365 9.22101 11.0453Z",
    stroke: "#F15A24",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_2261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.72c4cf921f4c4c145bb90a4b8f406edb.svg";
export { ForwardRef as ReactComponent };